import { render, staticRenderFns } from "./CcsqdDetail.vue?vue&type=template&id=b564ea4a&scoped=true&"
import script from "./CcsqdDetail.vue?vue&type=script&lang=js&"
export * from "./CcsqdDetail.vue?vue&type=script&lang=js&"
import style0 from "./CcsqdDetail.vue?vue&type=style&index=0&id=b564ea4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b564ea4a",
  null
  
)

export default component.exports